// Consistenze SSMATE (scheda cliente per lucchetto GRIGIO/VERDE): raggruppamento a categorie
// e label leggibili. Logica di sola presentazione, condivisa da desktop e PWA agente.

export const LUCCHETTO_HEX = {
  GRIGIO: '#9ca3af', VERDE: '#16a34a', NERO: '#111827', VIOLA: '#7c3aed',
  ROSSO: '#dc2626', GIALLO: '#eab308', ARANCIONE: '#f97316', 'NON TROVATO': '#cbd5e1',
};

export const SS_LABELS = {
  ragione_sociale: 'Ragione sociale', tipo_cliente: 'Tipo cliente', partita_iva: 'P. IVA',
  presidio: 'Presidio', categoria_merceologica: 'Categoria merceologica',
  partner_di_riferimento: 'Partner di riferimento', fatturato_cerved: 'Fatturato Cerved',
  potenziale_aggredibile_fisso: 'Potenziale fisso', potenziale_aggredibile_mobile: 'Potenziale mobile',
  potenziale_it: 'Potenziale IT', n_sedi: 'Sedi',
  n_linee_fonia: 'Linee fonia', n_linee_dati: 'Linee dati', n_offerte_tim_comunica: 'Offerte TIM Comunica',
  n_linee_ricaricabili_human: 'Ricaricabili (Human)', n_linee_abbonamento_human: 'Abbonamento (Human)',
  n_linee_m2m: 'Linee M2M', n_linee_m2m_applicative: 'M2M applicative', n_servizi_ict: 'Servizi ICT',
};

export const SS_CATEGORIE = [
  { id: 'Azienda', campi: ['ragione_sociale', 'tipo_cliente', 'partita_iva', 'presidio',
    'categoria_merceologica', 'partner_di_riferimento', 'fatturato_cerved',
    'potenziale_aggredibile_fisso', 'potenziale_aggredibile_mobile', 'potenziale_it', 'n_sedi'] },
  { id: 'Fisso', campi: ['n_linee_fonia', 'n_linee_dati', 'n_offerte_tim_comunica'] },
  { id: 'Mobile', campi: ['n_linee_ricaricabili_human', 'n_linee_abbonamento_human', 'n_linee_m2m', 'n_linee_m2m_applicative'] },
  { id: 'ICT', campi: ['n_servizi_ict'] },
];

// meta = campi mostrati altrove o tecnici, non nelle categorie
const META = new Set(['consistenze_aggiornate_al', 'codice_fiscale']);
const NOTI = new Set(SS_CATEGORIE.flatMap((c) => c.campi).concat([...META]));

const prettyKey = (k) => k.replace(/_+/g, ' ').trim().replace(/^\w/, (c) => c.toUpperCase());
const valorizzato = (v) => v != null && String(v).trim() !== '' && String(v).trim().toUpperCase() !== 'ND';

export function raggruppaConsistenze(dettaglio) {
  const det = dettaglio || {};
  const voce = (k) => ({ k, label: SS_LABELS[k] || prettyKey(k), valore: String(det[k]).trim() });
  const categorie = SS_CATEGORIE
    .map((c) => ({ id: c.id, voci: c.campi.filter((k) => valorizzato(det[k])).map(voce) }))
    .filter((c) => c.voci.length > 0);
  // campi non previsti (e non meta) confluiscono in Azienda, per non perdere nulla
  const extra = Object.keys(det).filter((k) => !NOTI.has(k) && valorizzato(det[k])).map(voce);
  if (extra.length) {
    const az = categorie.find((c) => c.id === 'Azienda');
    if (az) az.voci.push(...extra);
    else categorie.unshift({ id: 'Azienda', voci: extra });
  }
  return { categorie, aggiornateAl: det.consistenze_aggiornate_al || '' };
}
